var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3823_47838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6012 19.6068H16.4032V14.5943C16.4032 13.3991 16.3792 11.8608 14.7352 11.8608C13.0684 11.8608 12.814 13.1616 12.814 14.5068V19.6068H9.61482V9.29995H12.6868V10.704H12.7288C13.1584 9.89515 14.2024 9.03955 15.7624 9.03955C19.0024 9.03955 19.6024 11.1732 19.6024 13.9487V19.6068H19.6012ZM6.00282 7.88995C5.75868 7.89027 5.51689 7.84239 5.29129 7.74908C5.0657 7.65576 4.86074 7.51884 4.68817 7.34615C4.51559 7.17347 4.3788 6.96842 4.28563 6.74277C4.19246 6.51711 4.14474 6.27528 4.14522 6.03115C4.14546 5.66375 4.25463 5.30468 4.45895 4.99933C4.66326 4.69398 4.95353 4.45607 5.29305 4.31569C5.63258 4.17532 6.0061 4.13877 6.36639 4.21068C6.72669 4.28259 7.05757 4.45972 7.31719 4.71968C7.57681 4.97964 7.75352 5.31074 7.82496 5.67113C7.8964 6.03151 7.85937 6.40499 7.71856 6.74433C7.57774 7.08367 7.33946 7.37364 7.03385 7.57756C6.72823 7.78147 6.36902 7.89019 6.00162 7.88995H6.00282ZM7.60602 19.6068H4.39842V9.29995H7.60722V19.6068H7.60602ZM21.2032 1.19995H2.79402C1.91082 1.19995 1.19922 1.89595 1.19922 2.75635V21.2435C1.19922 22.1039 1.91202 22.7999 2.79282 22.7999H21.1984C22.0792 22.7999 22.7992 22.1039 22.7992 21.2435V2.75635C22.7992 1.89595 22.0792 1.19995 21.1984 1.19995H21.202H21.2032Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3823_47838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.336f671b79b36a361e84966678be7433.svg";
export { ForwardRef as ReactComponent };